// SPA et API sur des origins différentes (SPA :3000, API :443) en MDA →
// les URLs retournées par getLoginURL/getLogoutURL sont absolues (préfixées par
// REACT_APP_HOST_BACKEND). Les returnPath/errorPath passés en paramètres doivent
// eux aussi être absolus et pointer vers le SPA. Leur origin doit être whitelisté
// côté backend dans attestra_connect.allowed_return_origins (FRONTEND_URL).
export class AttestraConnect {
  private static getApiBaseUrl(): string {
    return process.env.REACT_APP_HOST_BACKEND || '';
  }

  static getLoginIRI(returnPath: string, errorPath: string): string {
    const state = window.btoa(
      JSON.stringify({
        returnPath,
        errorPath,
        lang: 'fr',
      })
    );
    return `/api/auth/session?state=${encodeURIComponent(state)}`;
  }

  static getLogoutIRI(returnPath: string): string {
    const state = window.btoa(JSON.stringify({ returnPath }));
    return `/api/auth/logout?state=${encodeURIComponent(state)}`;
  }

  static getRefreshURI(): string {
    return '/api/auth/refresh';
  }

  static getLoginURL(returnPath: string, errorPath: string): string {
    return `${AttestraConnect.getApiBaseUrl()}${AttestraConnect.getLoginIRI(
      returnPath,
      errorPath
    )}`;
  }

  // /logout_callback est whitelisté dans Cognito (Allowed sign-out URLs) et
  // dans attestra_connect.allowed_return_origins côté backend.
  static getLogoutURL(returnPath: string): string {
    return `${AttestraConnect.getApiBaseUrl()}${AttestraConnect.getLogoutIRI(returnPath)}`;
  }
}
